import {ajusteNomPersonne} from "./utilitaires.js";

export class OptionRecherche {

    static FILTRE_INCLURE_VERBES_CONJUGUÉS = {code: "INCLURE_VERBES_CONJUGUÉS", nom:"Toutes les formes, sauf les verbes conjugués"};
    static FILTRE_LEMMES_SEULEMENT = {code:"LEMMES_SEULEMENT", nom:" Lemmes seulement"};
    static FILTRE_TOUTES_LES_FORMES = {code:"AUCUN", nom:"Toutes les formes"};

    static FiltreLemmesSeulementOptions = [
        new OptionRecherche(OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code, "non"),
        new OptionRecherche(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code, "oui"),
    ]

    static FiltreToutesLesFormesSaufVerbesConjuguésOptions = [
        new OptionRecherche(OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code, "non"),
        new OptionRecherche(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code, "non"),
    ]

    static FiltreToutesLesFormesOptions = [
        new OptionRecherche(OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code, "oui"),
        new OptionRecherche(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code, "non"),
    ]


    constructor(code, valeur) {
        this.code = code || "";
        this.valeur = valeur || {};
    }

    static asTexte(option) {
        return option.code + " : " + option.valeur;
    }

}

